import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53be3a06"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "添加图片", -1))
const _hoisted_2 = { class: "submit-warp" }

import { ref, onMounted } from "vue";
import { chooseImage, uploadImage, previewImage } from "@/modular/Weixinh5";
import { publicSupplies } from "@/api/suppliesApi";
import { Toast as toast, Dialog as dialog } from 'vant';
import { useRouter } from "vue-router";
import { areaList as areaListData } from "@vant/area-data";
import { getForeverNewsAsync } from "@/api/WeixinH5Api";
import { Area as vanArea } from "vant";
import { localDataCore } from '@/modular/localData/localData'
import runEvn from "@/modular/runEvn/RunEvn";

export default /*#__PURE__*/_defineComponent({
  __name: 'Supplies',
  setup(__props) {

const fileBaseUrl = runEvn().fileBaseUrl;

const router = useRouter();
const areaList = ref(areaListData);

const formData = ref({
    donateName: "",
    phone: "",
    suppliesName: "",
    qty: "",
    oldAndNew: "",
    desc: "",
    suppliesImgs: "",
    imgs: [],
    address: "",
    province: "",
    city: "",
    district: "",
});
const area = ref({
    val: null,
    showPopover: false,
});

const maxImgLen = ref(9);
const onChooseImage = async function () {
    const chooseMaxImg =
        maxImgLen.value - formData.value.imgs.length;
    if (chooseMaxImg <= 0) {
        toast.fail("最多只能上传9张图片");
        return;
    }
    const ids = await chooseImage({
        count: chooseMaxImg, // 只能一个
        sizeType: ["compressed"], // 压缩图片
    });
    toast.loading({
        message: "图片上传中...",
        forbidClick: true,
        duration: 0,
    });

    try {
        for (let index = 0; index < ids.localIds.length; index++) {
            const localId = ids.localIds[index];
            const media_id = await uploadImage({
                localId: localId,
                isShowProgressTips: 0,
            });
            var imgKey = await getForeverNewsAsync(media_id);
            formData.value.imgs.push(imgKey);
            formData.value.suppliesImgs = formData.value.imgs.join(',');
        }
        toast.success("上传完成");
    } catch (error) {
        toast.fail("上传遇到问题");
    }
}
function delImg(index: number) {
    formData.value.imgs.splice(index, 1);
}
const img = (key: string) => fileBaseUrl + key;

onMounted(() => {
    initTestData();
});

const oldNewPicker = ref({
    show: false
});

function onOldNewConfirm(optData) {
    formData.value.oldAndNew = optData.id;
    oldNewPicker.value.show = false;
}

// 测试数据，isTest=true,方便调试新增
function initTestData() {
    const isTest = !true;
    if (isTest) {
        formData.value.donateName = "zhou";
        formData.value.phone = "15800008888";
        formData.value.suppliesName = "医疗急救包";
        formData.value.qty = "3";
        formData.value.oldAndNew = "9成新";
        formData.value.desc = "家里有闲置的医疗急救包3份，堆着也是浪费，想做点公益";
        formData.value.imgs = ["cCwuL3AvMjAyMTA5MTAvMTExOS8xLHhydjRtYWRiLmhqcy5wbmc="];
        formData.value.suppliesImgs = formData.value.imgs.join(',');
        formData.value.province = "广东省";
        formData.value.city = "广州市";
        formData.value.district = "天河区";
        area.value.val = `${formData.value.province}-${formData.value.city}-${formData.value.district}`;
        formData.value.address = "中山大道100号";
    }
}
function areaPickerConfirm(result: any) {
    const areaData = result.map((a: any) => a.name).join("-");
    area.value.val = areaData;
    formData.value.province = areaData[0];
    formData.value.city = areaData[1];
    formData.value.district = areaData[2];
    area.value.showPopover = false;
}

async function onSubmit() {
    toast.loading({});
    //发布
    const data = await publicSupplies(formData.value);
    if (!data) {
        toast.fail("发布失败");
        return;
    }
    dialog({ message: "发布成功" })
    router.push('/mulin');
}



// 电话号码验证
function checkTel(value: any) {
    let regPone = null;

    let mobile = /^1[3456789]\d{9}$/; //最新16手机正则
    let tel = /^(\d{3,4}-?)?\d{8}$/; //座机
    //et tel = null;
    if (value.charAt(0) == 0) {
        // charAt查找第一个字符方法，用来判断输入的是座机还是手机号
        regPone = tel;
    } else {
        regPone = mobile;
    }
    if (!regPone.test(value)) {
        return `请填写联系电话(座机格式'区号-座机号码')`;
    }
    return '';
}
const phoneRules: FieldRule[] = [
    { required: true, message: '请填写联系电话' },
    { validator: checkTel }];
const rules = ref({
    donateName: [{ required: true, message: '请填写捐赠人姓名' }],
    phone: phoneRules,
    suppliesName: [{ required: true, message: '请填写物资名字' }],
    qty: [{ required: true, message: '请填写物资数量' }],
    oldAndNew: [{ required: true, message: '请选择新旧程度' }],
    desc: [{ required: true, message: '请描述物资信息' }],
    area: [{ required: true, message: '选择省市区' }],
    address: [{ required: true, message: '请填写地址' }],
    imgs: [{ validator: (val) => val.length > 0 ? "" : "未添加图片" }]
});


const oldNewColumns = localDataCore.oldNewColumns;

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_RatioHeightContainer = _resolveComponent("RatioHeightContainer")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_form, {
      onSubmit: onSubmit,
      "input-align": "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, {
          modelValue: formData.value.donateName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.donateName) = $event)),
          label: "捐赠人姓名",
          maxlength: "5",
          placeholder: "请填写捐赠人姓名",
          rules: rules.value.donateName
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.phone,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.phone) = $event)),
          maxlength: "11",
          label: "联系电话",
          placeholder: "请填写联系电话",
          rules: rules.value.phone
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.suppliesName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.suppliesName) = $event)),
          maxlength: "30",
          label: "物资名字",
          placeholder: "请填写物资名字",
          rules: rules.value.suppliesName
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.qty,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.qty) = $event)),
          maxlength: "30",
          label: "物资数量",
          placeholder: "请填写物资数量",
          type: "digit",
          rules: rules.value.qty
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.oldAndNew,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.oldAndNew) = $event)),
          maxlength: "30",
          "is-link": "",
          readonly: "",
          label: "新旧程度",
          placeholder: "请选择新旧程度",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (oldNewPicker.value.show = true)),
          rules: rules.value.oldAndNew
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.desc,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.desc) = $event)),
          label: "物资描述",
          type: "textarea",
          placeholder: "请描述物资信息",
          rules: rules.value.desc
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: area.value.val,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((area.value.val) = $event)),
          label: "选择省市区",
          readonly: "",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (area.value.showPopover = true)),
          "right-icon": " iconfont d-dizhi addr-ico",
          rules: rules.value.area
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.address,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.address) = $event)),
          label: "地址",
          maxlength: "300",
          placeholder: "请填写地址",
          rules: rules.value.address
        }, null, 8, ["modelValue", "rules"]),
        _createVNode(_component_van_field, {
          modelValue: formData.value.suppliesImgs,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.suppliesImgs) = $event)),
          label: "附加照片",
          class: "d-flex-column",
          rules: rules.value.imgs
        }, {
          input: _withCtx(() => [
            _createVNode(_component_van_row, { class: "d-full-w img-wrapper" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.imgs, (item, index) => {
                  return (_openBlock(), _createBlock(_component_van_col, {
                    span: "6",
                    key: item,
                    class: "img-gutter"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_RatioHeightContainer, { ratio: 75 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_image, {
                            class: "picturer",
                            alt: "图片加载中...",
                            width: "100%",
                            height: "100%",
                            fit: "cover",
                            src: img(item),
                            onClick: ($event: any) => (_unref(previewImage)(item))
                          }, null, 8, ["src", "onClick"]),
                          _createVNode(_component_van_icon, {
                            name: "clear",
                            onClick: ($event: any) => (delImg(index)),
                            class: "del-img"
                          }, null, 8, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                _withDirectives(_createVNode(_component_van_col, {
                  span: "6",
                  class: "img-gutter"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "btn-add-img",
                      onClick: onChooseImage
                    }, [
                      _createVNode(_component_van_icon, { name: "plus" }),
                      _hoisted_1
                    ])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, 
                            formData.value.imgs.length <
                            maxImgLen.value
                        ]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "rules"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_button, {
            block: "",
            class: "btn-submit d-theme-btn",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 立即捐赠 ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_van_popup, {
      show: area.value.showPopover,
      "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((area.value.showPopover) = $event)),
      teleport: "body",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(vanArea), {
          onConfirm: areaPickerConfirm,
          "area-list": areaList.value,
          value: "440106"
        }, null, 8, ["area-list"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_action_sheet, {
      teleport: "body",
      "close-on-popstate": "",
      onSelect: onOldNewConfirm,
      round: false,
      show: oldNewPicker.value.show,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((oldNewPicker.value.show) = $event)),
      actions: _unref(oldNewColumns),
      "cancel-text": "取消",
      "close-on-click-action": "",
      onCancel: _cache[13] || (_cache[13] = ($event: any) => (oldNewPicker.value.show = false))
    }, null, 8, ["show", "actions"])
  ]))
}
}

})